// Where the Earnings pages send each other. Import-free, so the shell's top
// bar can use it without pulling the pages in.

export type EarningsView = "home" | "hub" | "calendar";

const VIEWS: readonly EarningsView[] = ["home", "hub", "calendar"];

/**
 * /earnings keeps its showing view in the history entry's state, so Back
 * from a report or a company page lands on the view it left (the views
 * share one URL).
 */
export const viewState = (view: EarningsView) => ({ earningsView: view });

/** The view a history entry's state names, if any. */
export const viewFromState = (state: unknown): EarningsView | null => {
  const view = (state as { earningsView?: unknown } | null)?.earningsView;
  return VIEWS.includes(view as EarningsView) ? (view as EarningsView) : null;
};

export const earningsReportPath = (eventId: string): string =>
  `/earnings/report/${encodeURIComponent(eventId)}`;

export const earningsCompanyPath = (symbol: string): string =>
  `/earnings/company/${encodeURIComponent(symbol)}`;

/** Where a report page's Back goes when there is no history to go back to. */
export const REPORT_BACK_FALLBACK = {
  to: "/earnings",
  state: viewState("hub"),
} as const;

export const isReportPath = (pathname: string): boolean =>
  pathname.startsWith("/earnings/report/");
